module.exports = __webpack_public_path__ + "static/media/Jay B.c1978641.png";